import React, { useState, useEffect, forwardRef } from "react";
import Article from "./Article";
import "../../css/small-article.scss";
import data from "../../../template/copy.json";
import { sum } from "d3";

const SmallArticle = forwardRef(({ article, x }, ref) => {
  const [top, setTop] = useState(0);
  const calcRandomTop = (article) => {
    const num = sum(article.title.split("").map((d) => d.charCodeAt(0)));
    const tens = (num + "")[0] > 5 ? 10 : 0;
    return tens + (num % 10);
  };
  useEffect(() => {
    setTop(
      (article.y || calcRandomTop(article) * 0.05) * window.innerHeight * 0.8
    );
  }, []);
  return (
    <a href={article.link}>
      <div
        className="small-article"
        style={{
          position: "absolute",
          left: x(new Date(article.date)),
          top: top ? window.innerHeight * 0.1 + top : 0,
        }}
        ref={ref}
      >
        {article.title}
      </div>
    </a>
  );
});

export default SmallArticle;
